import uiRouter from '@uirouter/angularjs';
import angular, { IScope }from 'angular';
import _ from 'lodash';

import { TODO, UIBModal, UIBModalService } from '@b2b/types/core';
import { PersonTypeModel } from '../types/index';

import { PricingDiscountsAddPersonTypeModalControllerModule } from './PricingDiscountsAddPersonTypeModalController';

PricingDiscountsController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$filter',
  '$uibModal',
  'ApiService',
  'ValidateService',
  'HelpersService',
  'NoticeFactory',
  'DiscountsData',
  'PersonTypesData',
];

function PricingDiscountsController(
  $scope: IScope & { pricingDiscounts: TODO },
  $state,
  $timeout,
  $filter,
  $uibModal: UIBModalService,
  ApiService,
  ValidateService,
  HelpersService,
  NoticeFactory,
  DiscountsData,
  PersonTypesData
) {
  const ctrl = {
    isLoaded: false,
    isSubmitted: false,
    notice: new NoticeFactory(),
    model: {} as PersonTypeModel,
    filtered: [],
    discountsList: [],
    personTypes: [],
    discountTypes: [
      {
        label: 'Percent',
        type: 'PercentageBased',
      },
      {
        label: 'Value',
        type: 'AmountBased',
      },
    ],

    defaultDiscountValues: {
      personTypeId: '',
      discountType: 'PercentageBased',
      value: '0',
    },

    searchQuery: '',

    componentType: 'discount',

    tab: 'individual',

    addModal: {} as UIBModal<any>,

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Discounts',
        buttonRight: {
          label: '+ Create Discount',
          permissions: 'DISCOUNTS_CREATE',
          action: function () {
            $scope.pricingDiscounts.create();
          },
        },
      });
      if (DiscountsData.data && DiscountsData.data.success) {
        this.success.init(DiscountsData);
      } else {
        this.error.init(DiscountsData);
      }

      if (PersonTypesData.data && PersonTypesData.data.success) {
        this.success.getPersonTypes(PersonTypesData);
      } else {
        this.error.getPersonTypes(PersonTypesData);
      }

      $scope.$on('PricingDiscountsSidebarController::selectList', this.onSidebarSelect);
    },

    getDiscountCode: function (id) {
      ApiService.discounts.detail(id).then(this.success.getDiscountCode, this.error.getDiscountCode);
    },

    getCleanValues: function () {
      var i,
        ii,
        clean = angular.copy(this.model);

      for (i = 0, ii = clean.values.length; i < ii; i++) {
        clean.values[i].selectedDiscountType = null;
        delete clean.values[i].selectedDiscountType;
        clean.values[i].value = '' + clean.values[i].displayValue.replace('%', '');

        clean.values[i].displayValue = null;
        delete clean.values[i].displayValue;
      }

      console.log('PricingDiscountsController::getCleanValues', clean);

      return clean;
    },

    createDiscountValues: function () {
      var i,
        ii,
        values = [] as TODO,
        discountValue = {} as TODO;

      for (i = 0, ii = this.personTypes.length; i < ii; i++) {
        discountValue = $.extend({}, this.defaultDiscountValues);
        discountValue.personTypeId = this.personTypes[i].id;
        values.push(discountValue);
      }
      console.log('createDiscountValues', values);

      return values;
    },

    remove: function () {
      var self = $scope.pricingDiscounts;

      self.addModal = $uibModal.open({
        templateUrl: 'views/application/views/pricing/discounts/modals/removeDiscount.tpl.html',
        size: 'md',
        controller: 'PricingDiscountsRemoveModalController',
        resolve: {
          currentDiscount: function () {
            return self.model;
          },
        },
      });

      // Invoked when modal completes with close(params)
      self.addModal.result.then(
        function (name) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          self.isRemoving = true;

          ApiService.discounts.remove(self.model.id).then(function (response) {
            var i, ii;

            for (i = 0, ii = self.discountsList.length; i < ii; i++) {
              if (self.discountsList[i].id === self.model.id) {
                self.discountsList.splice(i, 1);
                break;
              }
            }
            self.success.remove(response);
          }, self.error.remove);
        },
        function () {
          // Do nothing
        }
      );
    },

    create: function () {
      var self = $scope.pricingDiscounts;

      self.addModal = $uibModal.open({
        templateUrl: 'views/application/views/pricing/discounts/modals/createDiscount.tpl.html',
        size: 'lg',
        controller: 'PricingDiscountsCreateModalController',
        resolve: {
          discountsList: function () {
            return self.discountsList;
          },
        },
      });

      self.addModal.result.then(
        function (discount) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();

          discount.values = [];

          ApiService.discounts.create(discount).then(function (response) {
            discount.id = response.data.payload;

            self.success.create({
              data: {
                payload: discount,
              },
            });
          }, self.error.create);
        },
        function () {
          // Do nothing
        }
      );
    },

    addPersonTypes: function () {
      ctrl.addModal = $uibModal.open({
        templateUrl: 'views/application/views/pricing/discounts/modals/addPersonTypes.tpl.html',
        size: 'lg',
        controller: 'PricingDiscountsAddPersonTypeModalController',
        controllerAs: '$ctrl',
        resolve: {
          discount: function () {
            return ctrl.model;
          },
          personTypes: function () {
            return ctrl.personTypes;
          },
          tab: function () {
            return ctrl.tab;
          },
          discountTypes: function () {
            return ctrl.discountTypes;
          },
        },
      });

      ctrl.addModal.result.then(function (discount) {
        ctrl.model.values = discount.values;
      });
    },

    update: function () {
      this.notice.hideSuccessMessages();
      this.notice.hideErrorMessages();
      this.isSubmitted = true;
      if (
        ValidateService.validate([
          { len: { value: this.model.name } },
          { len: { value: this.model.description } },
          { len: { value: this.model.code } },
        ])
      ) {
        ApiService.discounts.update(this.getCleanValues()).then(this.success.update, this.error.update);
      } else {
        this.isSubmitted = false;
        this.notice.showErrorMessages([{ message: 'Please correct the errors below.' }]);
      }
    },

    hasValues: function () {
      return this.model.values instanceof Array && this.model.values.length > 0;
    },

    hasDiscounts: function () {
      return this.discountsList instanceof Array && this.discountsList.length > 0;
    },

    isValid: function (prop) {
      var r = true;

      r = ValidateService.validate([{ len: { value: this.model[prop] } }]);

      return r;
    },

    updateDiscountTicketTypeValue: function (index) {
      var self = this;

      // Give model time to update with changes
      $timeout(function () {
        self.formatTicketTypeValue(self.model.values[index]);
      }, 10);

      console.log('PricingDiscountsController::updateDiscountTicketTypeValue', self.model.values[index]);
    },

    formatTicketTypeValue: function (discount) {
      var value = '' as TODO,
        type = '';

      switch (discount.selectedDiscountType.type) {
        case 'PercentageBased':
          type = discount.selectedDiscountType.type;
          value = parseFloat(discount.displayValue);
          value.toPrecision(2);
          if (!value || value === 0 || isNaN(value)) {
            value = 0;
          }
          value = Math.abs(value);
          value += '%';
          break;
        case 'AmountBased':
          type = discount.selectedDiscountType.type;
        /* falls through */
        default:
          value = $filter('number')(discount.displayValue, 2);
          value = Math.abs(value) + '';
          if (!value || value === 0 || isNaN(value)) {
            value = '0.00';
          }
          break;
      }
      discount.discountType = type;
      discount.displayValue = value;
    },

    search: function () {
      this.filtered = $filter('filter')(this.discountsList, function (discount) {
        var name = discount.name + '|' + discount.code,
          value = name.toLowerCase();
        return value.indexOf($scope.pricingDiscounts.searchQuery.toLowerCase()) !== -1 ? discount : null;
      });
    },

    findDiscountType: function (type, returnObject) {
      var i,
        ii,
        r = false;
      console.log('PricingDiscountsController::findDiscountType', type);

      for (i = 0, ii = this.discountTypes.length; i < ii; i++) {
        if (type === this.discountTypes[i].type) {
          r = i;
          if (returnObject) {
            r = this.discountTypes[i];
          }
          break;
        }
      }

      return r;
    },

    process: function (discount) {
      var i, ii;

      for (i = 0, ii = discount.values.length; i < ii; i++) {
        discount.values[i].selectedDiscountType = this.findDiscountType(discount.values[i].discountType, true);
        discount.values[i].displayValue = discount.values[i].value;
        this.formatTicketTypeValue(discount.values[i]);
      }

      discount.values = _.orderBy(discount.values, ['personType.name', 'asc']);

      return discount;
    },

    isTab: function (tab) {
      return this.tab === tab;
    },

    getTab: function (tab) {
      this.tab = tab;
    },

    success: {
      init: function (response) {
        var self = $scope.pricingDiscounts;
        console.log('PricingDiscountsController::success::init');
        self.discountsList = response.data.payload.list;
        self.search();
        if (!self.hasDiscounts()) {
          self.isLoaded = true;
        }
        // Chokes without timeout
        $timeout(function () {
          $scope.$broadcast('PricingDiscountsController::discountCodesUpdate', { model: response.data.payload.list });
        }, 0);
      },

      remove: function (response) {
        $timeout(function () {
          $scope.$broadcast('PricingDiscountsController::discountCodesUpdate', {
            model: $scope.pricingDiscounts.discountsList,
          });
        }, 0);
      },

      create: function (response) {
        $scope.pricingDiscounts.discountsList.unshift(response.data.payload);
        $scope.$broadcast('PricingDiscountsController::discountCodesUpdate', {
          selectedDiscountCodeId: response.data.payload.id,
          model: $scope.pricingDiscounts.discountsList,
        });
      },

      update: function (response) {
        $scope.pricingDiscounts.isSubmitted = false;
        $scope.pricingDiscounts.notice.showSuccessMessages([
          {
            message: 'Successfully Updated!',
          },
        ]);
        $timeout(function () {
          $scope.pricingDiscounts.notice.hideSuccessMessages();
        }, 3000);
      },

      getPersonTypes: function () {
        $scope.pricingDiscounts.personTypes = PersonTypesData.data.payload.list;
      },

      getDiscountCode: function (response) {
        console.log('PricingDiscountsController::success::getDiscountCode', response.data.payload);
        $scope.pricingDiscounts.model = $scope.pricingDiscounts.process(response.data.payload);
        $scope.pricingDiscounts.isLoaded = true;
      },
    },

    error: {
      init: function (response) {
        $scope.pricingDiscounts.isLoaded = true;
      },
      create: function (response) {},
      update: function (response) {
        $scope.pricingDiscounts.notice.showErrorMessages([{ message: response.data.error }]);
      },
      getPersonTypes: function (response) {},
      getDiscountCode: function (response) {},
    },

    onSidebarSelect: function (e, data) {
      console.log('PricingDiscountsController::onSidebarSelect', data);
      $scope.pricingDiscounts.getDiscountCode(data.id);
    },
  };

  $scope.pricingDiscounts = ctrl;
  $scope.pricingDiscounts.init();
}

export const PricingDiscountsModule = angular
  .module('acme.view.application.pricing.discounts.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.validate',
    'acme.common.factory.notice',
    'acme.view.application.pricing.discounts.createModal.controllers',
    'acme.view.application.pricing.discounts.removeModal.controllers',
    PricingDiscountsAddPersonTypeModalControllerModule,
  ])
  .controller('PricingDiscountsController', PricingDiscountsController).name;
